<div class="global-loader">
    @if (loadingService.isLoading()) {
        <mat-progress-bar mode="indeterminate"/>
    }
</div>
<div #root class="layout is-open" [class.is-reduced]="isReducedLeftSideOpen()">
    <div class="top-decor" [class.is-open]="!isReducedLeftSideOpen()"></div>
    <div class="up">
        <header class="left-side__header">
            <div class="switcher" role="button" (click)="changeLeftSideMainWidth()"></div>
            <app-wide-header (click)="onWideHeaderClick($event)"/>
        </header>
        <header class="right-side__header">
            <div style="display: flex; align-items: center;">
                <a class="home" routerLink=""></a>
                <app-breadcrumbs/>
            </div>
            @if (doShowSearchString()) {
                <app-input [inputAttrs]="{placeholder: 'Поиск...'}" [formControl]="searchStringService.searchControl"
                           [trim]="true">
                    <div class="input-prefix">
                        <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M15.2083 9.16667C15.2083 5.82995 12.5034 3.125 9.16667 3.125C5.82995 3.125 3.125 5.82995 3.125 9.16667C3.125 12.5034 5.82995 15.2083 9.16667 15.2083C12.5034 15.2083 15.2083 12.5034 15.2083 9.16667ZM16.4583 9.16667C16.4583 10.9552 15.8131 12.5921 14.7445 13.8607L17.9419 17.0581L17.985 17.1053C18.1853 17.3508 18.1707 17.7131 17.9419 17.9419C17.7131 18.1707 17.3508 18.1853 17.1053 17.985L17.0581 17.9419L13.8607 14.7445C12.5921 15.8131 10.9552 16.4583 9.16667 16.4583C5.13959 16.4583 1.875 13.1937 1.875 9.16667C1.875 5.13959 5.13959 1.875 9.16667 1.875C13.1937 1.875 16.4583 5.13959 16.4583 9.16667Z"
                                fill="#190729" fill-opacity="0.54"/>
                        </svg>
                    </div>
                </app-input>
            }
        </header>

    </div>
    <div class="body">
        <main class="left-side__main" cdkScrollable>
            <app-menu [reduced]="isReducedLeftSideOpen()"/>
        </main>
        <main class="right-side__main">
            <div class="bottom-decor"></div>
            <div class="router-outlet">
                <router-outlet [routerOutletData]="searchControl.value"></router-outlet>
            </div>
        </main>
    </div>

    <div class="substrate" [class.active]="isOpenMobileMenu()" (click)="onClickOutside($event)">
        <div class="mobile-menu" #mobileMenu>
            <div class="top-decor"></div>
            <div class="mobile-menu__header">
                <app-wide-header (click)="onMobileMenuClick()"/>
            </div>
            <div class="mobile-menu__body">
                <app-menu [reduced]="isReducedLeftSideOpen()"/>
            </div>
        </div>
    </div>

</div>

